import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "technology-strip",
  "aria-label": "Principais tecnologias"
}
const _hoisted_2 = { class: "technology-list" }


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeTechnologies',
  props: {
    techStackIcons: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "technology-strip__label" }, "FERRAMENTAS /", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.techStackIcons, (technology) => {
        return (_openBlock(), _createElementBlock("li", {
          key: technology.name
        }, _toDisplayString(technology.name), 1))
      }), 128))
    ])
  ]))
}
}

})